/* global axios */
import ApiClient from './ApiClient';

// Agent-facing "My QA" client — hits /api/v1/accounts/:id/my_qa_incidents, which is
// OUTSIDE the permission-gated qa_dashboard prefix (any account member, self-scoped
// server-side to agent_user_id == current_user). Do NOT reuse qaDashboard.js.
class MyQaIncidentsAPI extends ApiClient {
  constructor() {
    super('my_qa_incidents', { accountScoped: true });
  }

  appeal(id, reason) {
    return axios.post(`${this.url}/${id}/appeal`, { reason });
  }
}

export default new MyQaIncidentsAPI();
